import SectionLayout from '../SectionLayout/SectionLayout.view'
import { BookOpen, Mail } from 'lucide-react'
import ButtonGroup from '../ButtonGroup/ButtonGroup.view'
import StatsCard from '@/components/Card/card'
import downloadIconUrl from '@/public/img/index_features/download.svg?url'
import githubIconUrl from '@/public/img/index_features/github.svg?url'

const SigNozStats = () => {
  const STATS_LIST = [
    {
      id: 1,
      logo: downloadIconUrl,
      name: 'OSS Downloads',
      value: '10 million+',
    },
    {
      id: 2,
      logo: githubIconUrl,
      name: 'GitHub Stars',
      value: '25k+',
    },
  ]

  const PlatformCard: React.FC<{ title: string; description: string }> = ({
    title,
    description,
  }) => (
    <div className="rounded-md border border-[var(--l2-border)] bg-[var(--l2-background)] p-4">
      <h3 className="mb-2 text-base font-medium text-[var(--l1-foreground)]">{title}</h3>
      <p className="mb-0 text-sm font-normal text-[var(--l2-foreground)]">{description}</p>
    </div>
  )

  const platformFeatures = [
    {
      title: 'SigNoz Cloud',
      description:
        'Fully managed, SOC 2-compliant, ideal for teams who want to start quickly without managing infrastructure.',
    },
    {
      title: 'Self-Hosted SigNoz',
      description:
        'For tighter security & data residency requirements. It is Apache 2.0 open source, built on open standards.',
    },
  ]

  const communityButtons = [
    {
      text: 'Join the community',
      href: 'https://signoz.io/slack/',
      variant: 'default' as const,
      icon: <BookOpen className="h-3 w-3 sm:h-3.5 sm:w-3.5" />,
    },
    {
      text: 'GitHub Repository',
      href: 'https://github.com/SigNoz/signoz/',
      variant: 'secondary' as const,
      icon: <BookOpen className="h-3 w-3 sm:h-3.5 sm:w-3.5" />,
    },
    {
      text: 'Read Our Newsletter',
      href: 'https://newsletter.signoz.io/?utm_source=signoz_website&utm_medium=feature_page&utm_campaign=newsletter',
      variant: 'secondary' as const,
      icon: <Mail className="h-3 w-3 sm:h-3.5 sm:w-3.5" />,
    },
  ]

  return (
    <SectionLayout variant="bordered" className="flex flex-col !px-0 md:flex-row">
      <div className="flex-1 border-b border-dashed border-[var(--l2-border)] md:border-b-0">
        <p className="pl-12 pt-10 text-left text-4xl font-bold !leading-[3.5rem] text-[var(--l1-foreground)] sm:text-4xl">
          Developers <br />
          Love
          <br />
          SigNoz
        </p>
      </div>

      <div className="flex min-w-0 flex-[2_2_0%] flex-col">
        <div className="border-l border-dashed border-[var(--l2-border)] bg-transparent p-0">
          <div className="p-10 md:p-6">
            <h2 className="text-2xl font-bold text-[var(--l1-foreground)]">
              Your data stays where you want
            </h2>
            <p className="text-base text-[var(--l2-foreground)]">
              Keep your data in the US, EU, or India with SigNoz Cloud, or run Self-Hosted SigNoz.
            </p>
            <div className="flex w-full flex-col gap-4">
              {platformFeatures.map((feature, index) => (
                <PlatformCard key={index} title={feature.title} description={feature.description} />
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 text-left md:grid-cols-2 [&>div]:!border-r [&>div]:border-l-0 [&>div]:border-[var(--l2-border)]">
            {STATS_LIST.map((stat, index) => (
              <StatsCard
                logo={stat.logo}
                stats={stat.value}
                description={stat.name}
                logoSize={24}
                key={index}
              />
            ))}
          </div>
          <div className="border-t border-dashed border-[var(--l2-border)] py-6 md:pl-10">
            <ButtonGroup
              buttons={communityButtons}
              className="flex-col flex-wrap gap-3 sm:flex-row"
            />
          </div>
        </div>
      </div>
    </SectionLayout>
  )
}

export default SigNozStats
